export class ApplicationError {

    private readonly name: string;
    private readonly data: any;

    constructor(private message: string, private errorData?: any) {
        this.name = 'ApplicationError';
        this.message = message;
        this.data = errorData; //(gxApi ErrorModel) OR (Angular form.$error) objects
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/errors/ApplicationError.ts